/**
 * Optional Supabase session.
 *
 * Deliberately lazy and optional: with no `VITE_SUPABASE_*` set, the app runs
 * against a backend in dev-auth mode and never asks anyone to sign in. That
 * keeps a fresh clone usable while leaving one clear place to switch real auth
 * on.
 *
 * Only the anon key ever appears here. A service-role key in a browser bundle
 * would hand every visitor full database access.
 */

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? ''
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY ?? ''

export const supabaseConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY)

const STORAGE_KEY = 'context-graph.access-token'

/**
 * The token the API client sends.
 *
 * Reading from storage rather than depending on `@supabase/supabase-js` keeps
 * that SDK out of the bundle until real auth is actually wanted — at which point
 * this is the one function to replace with `supabase.auth.getSession()`.
 */
export async function getAccessToken(): Promise<string | null> {
  if (!supabaseConfigured) return null
  try {
    return window.localStorage.getItem(STORAGE_KEY)
  } catch {
    // Storage can be blocked entirely in some privacy modes.
    return null
  }
}

export function setAccessToken(token: string | null): void {
  try {
    if (token) window.localStorage.setItem(STORAGE_KEY, token)
    else window.localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* nothing we can do */
  }
}
